import { FC, ReactNode } from "react"
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material"
import { blockBackdropClose } from "./dialogUtils"

interface IProps {
  open: boolean
  title: string
  description?: ReactNode
  content?: ReactNode
  confirmText?: string
  cancelText?: string
  loading?: boolean
  onConfirm: () => void
  onCancel: () => void
}

/** Диалог подтверждения деструктивного действия. */
export const ConfirmDialog: FC<IProps> = ({
  open,
  title,
  description,
  content,
  confirmText = "Подтвердить",
  cancelText = "Отмена",
  loading = false,
  onConfirm,
  onCancel,
}) => (
  <Dialog
    open={open}
    onClose={blockBackdropClose(onCancel)}
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle>{title}</DialogTitle>
    {description && (
      <DialogContent>
        <DialogContentText>{description}</DialogContentText>
      </DialogContent>
    )}
    {content && <DialogContent>{content}</DialogContent>}
    <DialogActions>
      <Button onClick={onCancel} disabled={loading}>
        {cancelText}
      </Button>
      <Button
        onClick={onConfirm}
        color="error"
        variant="contained"
        disabled={loading}
        startIcon={loading ? <CircularProgress size={16} /> : undefined}
      >
        {confirmText}
      </Button>
    </DialogActions>
  </Dialog>
)
